





































import Vue from 'vue';
import Component from 'vue-class-component';
import { getModule } from 'vuex-module-decorators';
import Transcription from '@/store/modules/transcription';
import store from '@/store/store';
import { downloadDocx } from '@/utils/download';

const trscModule = getModule(Transcription, store);

@Component
export default class TrscView extends Vue {
  get entry() {
    return trscModule.entry;
  }

  get related() {
    if (!this.entry.related) return null;
    if (typeof this.entry.related === 'string') {
      return this.entry.related;
    } else {
      return this.entry.related['@id'];
    }
  }

  async download() {
    return await downloadDocx(this.entry.id);
  }
}
